import { createFileRoute } from '@tanstack/react-router'
import { HomePage } from '@/features/dashboard'

export const Route = createFileRoute('/')({
  component: HomePage,
})
